import $ from 'jquery';

const $svjq = (window.$svjq = window.jQuery = $.noConflict());

export default $svjq;
